import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  userData: null,
  isLoading: false,
  error: null,
  isAuthenticated: false,
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserData: (state, action) => {
      state.userData = action.payload;
      state.isLoading = false;
      state.isAuthenticated = true;
    },
    setUserError: (state, action) => {
      state.error = action.payload;
      state.isLoading = false;
    },
    setLoading: (state) => {
      state.isLoading = true;
    },
    resetUser: (state) => {
      state.userData = null;
      state.isLoading = false;
      state.error = null;
      state.isAuthenticated = false;
    },
    logout: (state) => {
      state.userData = null;
      state.isAuthenticated = false;
      state.error = null;
    },
  },
});

export const { setUserData, setUserError, setLoading, resetUser, logout } = userSlice.actions;

export const fetchUserData = (accessToken) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/user/self-identification`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    dispatch(setUserData(response.data));
  } catch (error) {
    dispatch(setUserError(error.message));
    localStorage.removeItem('NCProAccessToken');
    localStorage.removeItem('NCProRefreshToken');
  }
};

export default userSlice.reducer;